<template>
<div :style="scaleStyle"
     ref="previewMain"
     :class="{'is-sample': isSample, 'is-preview': !isSample}" >


    <div id="preview-page-01" class="doc-paper preview rirekisho" style="padding: 30px;">
      <div class="rirekisho-header" style="justify-content: center; margin-bottom: 1px;line-height: 1.5; margin-top: -8px;">
        <div class="title" style="margin-right: 0;">履歴書</div>
      </div>
      <div class="date" @click="goCardTo('create-date')" style="text-align: right;"
            :class="highLightClass('create-date')" v-html="formatedCreateDate"></div>
      <div class="flex">
        <div class="rirekisho-box1" style="width: 500px;">
          <div class="rirekisho-profile"
            style="border: solid 1px rgba(0, 0, 0, 1); border-bottom: none; border-right: 2px solid rgba(0, 0, 0, 1); border-left: 2px solid rgba(0, 0, 0, 1);">
            <div 
                @click="goCardTo('edu-historyBaika')"
                :class="highLightClass(['edu-historyBaika'])"
                class="etc flex" style="border-bottom: 1px solid rgba(0, 0, 0, 1); height: auto; font-size: 12px;">
              <div class="label"
                style="width: 20mm; padding-left: 2mm; border-right: 1px solid rgba(0, 0, 0, 1); height: 100%; display: flex; align-items: center;">
                梅花女子大学</div>
              <div class="faculty"
                style=" display: flex; align-items: center; padding-left: 2mm;">
                <span v-if="formatData.facultyBaika">{{ formatData.facultyBaika }}</span><span v-else>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</span>
                &emsp;
                <span v-if="formatData.departmentBaika">{{ formatData.departmentBaika }}</span><span v-else>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</span>
              </div>
            </div>
            <div class="flex" style="justify-content: space-between;">
            </div>
            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('profile')"
              :class="highLightClass('profile')">
              <div class="ruby flex" style="height: 21px;">
                <div class="label"
                  style="justify-content: center;text-align:center; width: 20mm; padding-left: 1mm;padding-right: 1mm; font-size: 12px; border-right: 1px solid rgba(0, 0, 0, 1); height: 100%; display: flex; align-items: center;">
                  ふりがな</div>
                <div class="input" style=" padding-left: 5px;font-size: 12px; ">
                  {{ basicData.lastNameFurigana }}&emsp;{{ basicData.firstNameFurigana }}</div>
              </div>
              <div class="name flex" style="height: 40px;">
                <div class="label"
                  style="justify-content: center;text-align:center;width: 20mm; padding-left: 1mm;padding-right: 1mm; font-size: 12px; border-right: 1px solid rgba(0, 0, 0, 1); height: 100%; display: flex; align-items: center;">
                  氏&emsp;名</div>
                <div class="input" style=" padding-left: 5px;">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}
                </div>
              </div>
            </div>
          </div>
          <div 
            @click="goCardTo('profile')"
            :class="highLightClass('profile')"
            class="etc flex bd"
            style="border: 1px solid rgba(0, 0, 0, 1); font-size: 12px; border-right: 2px solid rgba(0, 0, 0, 1); border-left: 2px solid rgba(0, 0, 0, 1);">
            <div class="label"
              style="justify-content: center;text-align:center;width: 20mm; padding-left: 1mm;padding-right: 1mm; border-right: 1px solid rgba(0, 0, 0, 1); height: 100%; display: flex; align-items: center;">
              生年月日</div>
            <div class="birthday" style="">（西暦）<span class="year">{{ basicData.birthYear }}</span>年 <span 
            class="month">{{ basicData.birthMonth }}</span>月 <span class="day">{{ basicData.birthDay }}</span>日生（満 <span
                class="age">{{ age }}</span> 歳）
            </div>
          </div>
          <div class="contact-information contact-main flex"
            @click="goCardTo('address')"
            :class="highLightClass('address')" >
            <div class="contact-information-address"
              style="width: 100%; height: auto; border-right: 2px solid rgba(0, 0, 0, 1); border-left: 2px solid rgba(0, 0, 0, 1);">
              <div class="ruby flex">
                <div class="label"
                  style="justify-content: center;text-align:center;padding-left: 1mm;padding-right: 1mm;display: flex; align-items: center; border-right: 1px solid rgba(0, 0, 0, 1); display: flex; align-items: center; height: 100%;">
                  ふりがな</div>
                <div class="input" style=" padding-left: 5px;" :class="classObject.addressFurigana">{{ basicData.addressFurigana }}
                </div>
              </div>
              <div class="address flex" style="height: 55px;">
                <div class="label"
                  style="justify-content: center;text-align:center;padding-left: 1mm;padding-right: 1mm;display: flex; align-items: center; padding-bottom: 15px;border-right: 1px solid rgba(0, 0, 0, 1);	display: flex; align-items: center;">
                  現住所</div>
                <div class="input" style="padding-left: 5px;">
                  <div class="postal-code" style="font-size: 0.8rem;">&#12306;{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
                  <pre style="font-size: 0.8rem;">{{ basicData.address1}}
{{ basicData.address2 }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div 
          @click="goCardTo('id-photo')"
          :class="highLightClass('id-photo')" class="rirekisho-photo">
          <div v-if="basicData.idPhotoSrc">
            <img :src="basicData.idPhotoSrc"
                alt="証明写真">
          </div>
          <div v-else>
            <div class="rirekisho-photo-inner" style="text-align: center;">
              <!--<p>証明写真</p>-->
              <p>写真貼付欄<br>(30mm×40mm)<br>写真裏面記入事項<br>大学名<br>学部・学科名<br>氏名</p>
            </div>
          </div>
        </div>
      </div>

      <div class="contact-information contact-sub flex"
        @click="goCardTo('contacts')"
        :class="highLightClass('contacts')"
        style="border-right: 2px solid rgba(0, 0, 0, 1); border-bottom: 2px solid rgba(0, 0, 0, 1);">
        <div class="contact-information-address" style="width: 50%;">
          <div class="tel flex" style="border-right: 1px solid rgba(0, 0, 0, 1);">
            <div class="label"
              style="justify-content: center;text-align:center;border-right: 1px solid rgba(0, 0, 0, 1); border-left: 2px solid rgba(0, 0, 0, 1); width: 20mm; padding-left: 1mm;padding-right: 1mm; display: flex; align-items: center; font-size: 12px; padding-top: 5px; padding-bottom: 5px;">
              連絡先</div>
            <div class="label"
              style="border-right: 1px solid rgba(0, 0, 0, 1); width: 23.5mm; padding-left: 2mm; display: flex; align-items: center; font-size: 12px;justify-content: center;justify-content: center;">
              電話番号</div>
            <div class="input"
              style=" align-items: center; display: flex; padding-left: 5px; width: auto; margin: 0 auto;">
              {{ tel }}</div>
          </div>
        </div>
        <div class="tel flex">
          <div class="label"
            style="display: flex; align-items: center; width: 23.5mm; padding: 0 0.5mm; border-right: 1px solid rgba(0, 0, 0, 1); font-size: 12px; justify-content: center;">
            E-mail</div>
        </div>
        <div class="email flex" style="margin: 0 auto;">
          <div class="input"
            style=" text-align: center; padding-left: 5px; width: 100%; align-items: center; display: flex;">
            {{ basicData.email }}</div>
        </div>
      </div>

      <div data-highlight="クリックで編集" class="rirekisho-table rirekisho-history-1">
        <table style="border: solid 2px rgba(0, 0, 0, 1);">
          <thead>
            <tr style="height: 22px;">
              <th style="font-size: 0.8rem;height: 22px;padding:0px;">年(西暦)</th>
              <td style="font-size: 0.8rem;height: 22px;padding:0px;">月</td>
              <td colspan="5" style="font-size: 0.8rem;height: 22px;padding:0px;">学歴・職歴</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in eduJobHistoryTable4New"
              v-bind:class="item.classObject"
              v-if="index < 9"
              :key="index">
              <th style=" padding: 0px 8px; height: 22px;padding:0px;">{{ item.year }}</th>
              <td style=" padding: 0px 8px; height: 22px; font-size: 0.8rem;padding:0px;">{{ item.month }}</td>
              <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" colspan="5" style=" padding: 0px 8px; height: 22px; font-size: 0.8rem">{{ item.description }}</td>
            </tr>
          </tbody>
        </table>
        <div class="rirekisho-pr" style="height: 120px;border-top: solid 2px rgba(0, 0, 0, 1);border-left: solid 2px rgba(0, 0, 0, 1);border-right: solid 2px rgba(0, 0, 0, 1);border-bottom: solid 1px rgba(0, 0, 0, 1);">
          <div @click="goCardTo('reasonBaika_1')"
         :class="highLightClass(['reasonBaika_1'])" class="rirekisho-jis-pr-reason">
            <div class="input">
              <pre class=""
                style=" white-space: pre-wrap; margin-top: 0;font-size: 0.8rem;">[自己PR]&emsp;{{ formatData.mypr1 }}</pre>
            </div>
          </div><!---->
        </div>
        <div class="rirekisho-pr" style="margin-top: 0; border-top: 0; height: 120px;border-top: solid 1px rgba(0, 0, 0, 1);border-left: solid 2px rgba(0, 0, 0, 1);border-right: solid 2px rgba(0, 0, 0, 1);border-bottom: solid 1px rgba(0, 0, 0, 1);">
          <div @click="goCardTo('reasonBaika_2')"
         :class="highLightClass(['reasonBaika_2'])" class="rirekisho-jis-pr-reason">
            <div class="input">
              <pre class=""
                style=" white-space: pre-wrap; margin-top: 0;font-size: 0.8rem;">[学生時代に力を注いだこと]&emsp;{{ formatData.mypr2 }}</pre>
            </div>
          </div><!---->
        </div>
        <div class="rirekisho-pr" style="margin-top: 0; border-top: 0; height: 95px;border-top: 0; border-top: solid 1px rgba(0, 0, 0, 1);border-left: solid 2px rgba(0, 0, 0, 1);border-right: solid 2px rgba(0, 0, 0, 1);border-bottom: solid 1px rgba(0, 0, 0, 1);">
          <div @click="goCardTo('requestsBaika')"
         :class="highLightClass(['requestsBaika'])"  class="rirekisho-jis-pr-reason">
            <div class="input">
              <pre class=""
                style=" white-space: pre-wrap; margin-top: 0;font-size: 0.8rem;">[志望動機]&emsp;{{ formatData.reason }}</pre>
            </div>
          </div><!---->
        </div>
        <div class="rirekisho-pr" style="margin-top: 0; border-top: 0; height: 50px;border-top: 0; border-top: solid 1px rgba(0, 0, 0, 1);border-left: solid 2px rgba(0, 0, 0, 1);border-right: solid 2px rgba(0, 0, 0, 1);border-bottom: solid 1px rgba(0, 0, 0, 1);">
          <div @click="goCardTo('etcBaika')"
         :class="highLightClass(['etcBaika'])"  class="rirekisho-jis-pr-reason">
            <div class="input">
              <pre class=""
                style=" white-space: pre-wrap; margin-top: 0;font-size: 0.8rem;">[研究課題]&emsp;{{ formatData.research_challenge }}</pre>
            </div>
          </div><!---->
        </div>
        <div class="rirekisho-pr" style="margin-top: 0; border-top: 0; height: 100px;border-top: 0; border-top: solid 1px rgba(0, 0, 0, 1);border-left: solid 2px rgba(0, 0, 0, 1);border-right: solid 2px rgba(0, 0, 0, 1);border-bottom: solid 2px rgba(0, 0, 0, 1);">
          <div @click="goCardTo('etcBaika')"
         :class="highLightClass(['etcBaika'])"  style="display: flex; width: 100%;">
            <div style="width: 50%; padding: 4px; border-right: 1px solid rgba(0, 0, 0, 1);">
              <div class="label">[趣味・特技]</div>
              <div class="input">
                <pre class=""
                  style=" white-space: pre-wrap; margin-top: 0;font-size: 0.8rem;">{{ formatData.hobby }}</pre>
              </div>
            </div>
            <div style="width: 50%; padding: 4px;">
              <div class="label">[資格・免許]</div>
              <div class="input">
                <pre class=""
                  style=" white-space: pre-wrap; margin-top: 0;font-size: 0.8rem;">{{ formatData.license }}</pre>
              </div>
            </div>
          </div><!---->
        </div>
        <p style="text-align: center; font-weight: bold; margin-top: 0;">梅花女子大学</p>
      </div>
    </div>

</div>
</template>
<script>
import RirekishoPreviewMixin from '@/mixins/gardenbaika-rirekisho-preview-mixin'
export default {
  name: 'rirekishogardenbaikaPreview',
  props: {
    formatId: {
      type: String
    }
  },
  mixins: [RirekishoPreviewMixin],
  data: function () {
    return {
      maxEduJobRows: 22,
      maxLicenseRows: 6,
      textareaMaxHeights: {
        reason: 180,
        request: 180
      }
    }
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('reason')
      this.adjustFontSize('reasonNew')
      this.adjustFontSize('request')
      this.adjustFontSize('addressFurigana')
    }
  }
}
</script>
